import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Profile } from 'src/model/profile.model';
import { ProfileService } from 'src/services/profile.service';

@Component({
    selector: 'app-update-profile-info',
    templateUrl: './update-profile-info.component.html',
    styleUrls: ['./update-profile-info.component.scss'],
    standalone: false
})
export class UpdateProfileInfoComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private profileService = inject(ProfileService);

  profileToUpdate: Profile;
  profileNew: Profile;

  disableSubmit = false;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.profileNew = Object.assign(new Profile(), this.profileToUpdate);
  }

  validFields() {
    const customerCodeNull = (this.profileNew.CompanyCode === '');
    const custOccupationNull = (this.profileNew.Occupation === '');
    const salaryAmountNull = this.profileNew.Salary == undefined;
    const salaryDayNull = this.profileNew.SalaryDay == undefined;

    return (custOccupationNull || customerCodeNull || salaryAmountNull || salaryDayNull)
  }

  async updateProfile() {
    this.disableSubmit = true;
    try {
      const profile = await this.profileService.updateProfile(this.profileNew);
      this.passEntry.emit(profile);
      this.reset();
      this.sharedService.openAlert("Successfully updated profile", ALERT_TYPE.SUCCESS);
    } finally {
      this.disableSubmit = false;
    }
  }

  submit() {
    (this.validFields() == true) ? this.sharedService.openAlert("Please fill in all the fields correctly", ALERT_TYPE.DANGER) : this.updateProfile();
  }

  reset() {
    this.profileToUpdate = null;
    this.activeModal.close();
  }
}
